
import { Routes, Route } from 'react-router-dom';
import sanga3 from "../../assets/camb2.jpg";
import { useState } from 'react';
import axios from 'axios';
import Aos from 'aos';
import 'aos/dist/aos.css'
import { useTranslation } from "react-i18next";

import camb3 from "../../assets/camb (13).jpg"

import camb5 from "../../assets/camb (15).jpg"

import faja from "../../assets/campland (2).jpg"
import faja2 from "../../assets/campland (3).jpg"
import faja3 from "../../assets/campland (4).jpg"
import salada from "../../assets/campland (1).jpg"
import salada2 from "../../assets/campland (5).jpg"
import salada3 from "../../assets/campland (6).jpg"
import salada4 from "../../assets/campland (7).jpg"
import masharf from "../../assets/masharf (1).jpg"
import masharf1 from "../../assets/masharf (2).jpg"
import masharf2 from "../../assets/masharf (3).jpg"
import masharf3 from "../../assets/masharf (4).jpg"
import aroos from "../../assets/aroos (1).jpg"
import aroos1 from "../../assets/aroos (2).jpg"
import aroos2 from "../../assets/aroos (3).jpg"
import aroos3 from "../../assets/aroos (4).jpg"

import aroos4 from "../../assets/arooos (1).jpg"
import aroos5 from "../../assets/arooos (2).jpg"
import aroos6 from "../../assets/arooos (3).jpg"
import aroos7 from "../../assets/arooos (4).jpg"
import aroos8 from "../../assets/arooos (5).jpg"

import mgool from "../../assets/aroos (5).jpg"
import mgool1 from "../../assets/aroos (6).jpg"
import mgool2 from "../../assets/aroos (7).jpg"
import mgool3 from "../../assets/aroos (8).jpg"
import mgool4 from "../../assets/aroos (9).jpg"

import { useEffect } from 'react';


import { API_URL } from "../../config";

export default function Arkaweet() {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();

  const images = [faja, faja2, faja3];
  const images2 = [salada, salada2, salada3, salada4, camb3, camb5];
  const images3 = [masharf, masharf2, masharf1, masharf3];
  const images4 = [aroos,
    aroos1,
    aroos2,
    aroos3, aroos4,
    aroos5,
    aroos6,
    aroos7,
    aroos8];

  const images5 = [mgool,
    mgool1,
    mgool2,
    mgool3,
    mgool4];
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    people: "",
    phone: "",
    date: "",
    passport: null,
    trip: ""

  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "passport" && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firstname.trim() || !formData.trip.trim() || !formData.people.trim() || !formData.phone.trim()
      || !formData.date.trim() || !formData.passport) {
      alert("فضلاً املئي كل الحقول");
      return;
    }

    const data = {
      firstname: formData.firstname,
      people: formData.people,
      phone: formData.phone,
      date: formData.date,
      passport: formData.passport?.name || "uploaded",
      trip: formData.trip
    };

    try {
      await axios.post(`${API_URL}/cambing`, data);
      alert('تم الحجز بنجاح ✅');
      setFormData({ firstname: "", people: "", phone: "", date: "", passport: null, trip: "" });
      setPreview(null);
    }
    catch (err) {
      console.log(err);
      alert("حدث خطأ: " + (err.response?.data?.error || err.message));
    }
  };
  const [price, setPrice] = useState([]);
  useEffect(() => {
    async function getPrice() {
      try {
        const responce = await axios.get(`${API_URL}/prices`);
        setPrice(responce.data);
      }
      catch (error) {
        console.error(error)
      }
    } getPrice();
  }, []);

  return (

    <div className="bg-green-30 h-full" >

      <div className="w-full h-full relative" >
        <img src={sanga3} className="hidden lg:block w-full h-full object-cover" />

        <div className='lg:absolute gap-6  inset-0 bg-black/40 flex  flex-col items-center justify-center lg:flex-row'>

          <img src={sanga3} className="lg:hidden w-full h-full absolute  top-0 object-cover " />

          <div data-aos="fade-right"
            className="lg:relative  flex items-center flex-col rtl h-full p-4 lg:m-6 justify-center" >
            <h1 className="text-white text-3xl lg:text-6xl font-bold">{t("hero3")} </h1>
            <h3 className="text-white  text-xl lg:text-xl font-bold p-4">{t("hero2")}</h3>
          </div>

          <form onSubmit={handleSubmit} data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"}
            className="mx-4 rounded-[20px] w-full max-w-[500px]
  mx-w-md mx-auto mt-10 p-4  items-center 
 justify-center bg-black/50 text-white mb-0" >
            <div className="space-y-12">
              {price.filter((el) => el.id === "3").map((item) => (<div className="border-b border-gray-900/10 justify-centet items-center">
                <h2 className="text-base/7 font-semibold text-white justify-center items-center">{t("form")} </h2>

                <h2 className="text-base/7 font-semibold text-white justify-center items-center">${item.price}</h2>

                <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("name")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='text' value={formData.firstname} id="first-name" name="firstname" autocomplete="given-name"
                        className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium ">{t("phone")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} id="email" type="tel" value={formData.phone} name="phone" autocomplete="phone" className="block border  w-full rounded-md bg-blue-100/50 px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300sm:text-sm/6" />
                    </div>
                  </div>


                  <div className="sm:col-span-3">
                    <label htmlFor="first-name" className="block text-sm/6 font-medium ">{t("date3")}</label>
                    <div className="mt-2">
                      <input onChange={handleChange} type='date' value={formData.date} id="first-name" name="date" autocomplete="given-name"
                        className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6" />
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-white">{t("people")}</label>
                    <div className="mt-2">
                      <select value={formData.people} onChange={handleChange} name="people" className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                        <option value="">{t("people")}</option>
                        <option value="10 - 20">10 - 20</option>
                        <option value="20 - 50">20 - 50</option>
                      </select>
                    </div>
                  </div>

                  <div className="sm:col-span-3">
                    <label htmlFor="email" className="block text-sm/6 font-medium text-white">{t("trips")}</label>
                    <div className="mt-2">
                      <select value={formData.trip} onChange={handleChange} name="trip"
                        className="block bg-blue-100/50 border w-full rounded-md 
             px-3 py-1.5 text-base text-gray-900 outline-1
              -outline-offset-1 outline-gray-300 placeholder:text-gray-400 
              focus:outline-2 focus:-outline-offset-2 focus:outline-blue-300 sm:text-sm/6">
                        <option value="">{t("cambing")}</option>
                        <option value="Aroos">{t("aroos")}</option>
                        <option value="Arkweet">{t("arkweet")}</option>
                        <option value="Faja Island">{t("faja")}</option>
                        <option value="Masharef">{t("masharf")}</option>
                        <option value="Mohamed Gool">{t("gool")}</option>
                        <option value="Salada">{t("salada")}</option>
                        <option value="Darah">{t("durah")}</option>


                      </select>
                    </div>
                  </div>



                  <div className="sm:col-span-6">
                    <div className="border-b border-gray-900/10 pb-12">
                      <div className="mt-2 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="col-span-full">
                          <label htmlFor="cover-photo" className="block text-sm/6 font-medium">{t("photo")}</label>
                          <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25">
                            <div className="text-center">

                              <div className="mt-4 flex text-sm/6 text-gray-600">
                                <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold
                 text-indigo-600 focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 
    ]focus-within:outline-hidden hover:text-indigo-500">
                                  <span>Upload a file</span>
                                  <input type="file" name="passport" onChange={handleChange} accept='image/*' />
                                  {preview && (
                                    <img
                                      src={preview}
                                      alt="passport preview"
                                      className="mt-4 w-20 h-20 object-cover rounded-md"
                                    />
                                  )}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>))}
            </div>

            <div className=" flex items-center justify-end gap-x-6">

              <button type="submit" className="rounded-md w-full bg-yellow-700 px-3 py-2 text-sm font-semibold 
    text-white shadow-xs hover:bg-yellow-600 focus-visible:outline-2 focus-visible:outline-offset-2
     focus-visible:outline-yellow-600">{t("send")}</button>
            </div>
          </form>

        </div>

      </div>

      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("faja")}</h2>
          <p className="text-gray-700 ">
            {t("faja-story")}
          </p>
        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={faja} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("faja")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>


      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("salada")}</h2>
          <p className="text-gray-700 ">
            {t("salada-story")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={salada2} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("salada")} {t("Galary")} </h1></center>

        <div data-aos="fade-up" className=' justify-items-center items-center max-w-6xl mx-auto grid  md:grid-cols-3 gap-4 sm:grid-cols-2 grid-cols-1 '>

          {images2.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div>

      </div>


      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("durah")}</h2>
          <p className="text-gray-700 ">
            {t("durah-story")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={faja} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("durah")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>


      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("arkweet")}</h2>
          <p className="text-gray-700 ">
            {t("arkweet-story")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={faja} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("arkweet")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>

      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("aroos")}</h2>
          <p className="text-gray-700 ">
            {t("aroos-story")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={aroos} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("aroos")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images4.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>

      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("masharf")}</h2>
          <p className="text-gray-700 ">
            {t("masharf-story")}

          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={masharf} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("masharf")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images3.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>


      {/* ////////////////////////////////////////////// */}

      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className=" ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("gool")}</h2>
          <p className="text-gray-700 ">
            {t("mgool-story")}

          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] w-full '>
          <img src={mgool} data-aos="fade-right" className="md:w-[80%] md:h-[40%] p-4 object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>

      {/* //////////////////////////////// */}


      <div className='w-full  my-6 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'>{t("gool")} {t("Galary")} </h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images5.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>



    </div>
  );

}
